export const conversationalTerritories = "/:app_group_id/conversational/territories";
